import { useCallback, useMemo, useState } from 'react'
import placeholderImage from '@/checkout-instore-legacy/assets/images/sku-placeholder.svg'

import {
  cleanImageUrl,
  getImageUrlSize,
  replaceHttpToRelativeProtocol,
} from './utils'

export type UseProductImageProps = {
  src?: string
  sizeInPx: number
}

export const useProductImage = ({
  src: initialSrc,
  sizeInPx,
}: UseProductImageProps) => {
  const [hasError, setHasError] = useState(false)

  const src = useMemo(() => {
    const isSrcValid = !!initialSrc && !hasError

    return isSrcValid
      ? getImageUrlSize({
          imageUrl: cleanImageUrl(replaceHttpToRelativeProtocol(initialSrc)),
          width: sizeInPx,
          height: sizeInPx,
          highDensityFactor: window.devicePixelRatio,
        })
      : ((placeholderImage as unknown) as string)
  }, [initialSrc, sizeInPx, hasError])

  const handleImageError = useCallback(() => {
    setHasError(true)
  }, [])

  return {
    src,
    handleImageError,
  }
}
